import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Tenant {
  id: number;
  name: string;
  nameDisplay: string;
  hasMFA: boolean;
  Domain: string;
  customerId?: string | null;
}

export interface Customer {
  id: number;
  name: string;
  nameDisplay: string;
  parentTenant:{
    parentTenantId: string;
  }
  customerId?: string | null;
}

export interface ProductListItem {
  id: number;
  name: string;
}

export interface UserProfile {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  NumberPhone: string;
  position: string;
  meta_data: {
    mfa_active: boolean;
  };
  tenantId: number;
  Tenant: Tenant;
  TenantType: string;
  ProductList: ProductListItem[];
  ListPermiso: string[];
  hash: string;
  emailDomain: string;
  canAccessAlerts: boolean;
}

// Estado inicial...
const initialState: UserProfile = {
  id: "",
  firstName: "",
  lastName: "",
  email: "",
  NumberPhone: "",
  position: "",
  meta_data: {
    mfa_active: false,
  },
  tenantId: 0,
  Tenant: {
    id: 0,
    name: "",
    nameDisplay: "",
    hasMFA: false,
    Domain: "",
  },
  TenantType: "",
  ProductList: [],
  ListPermiso: [],
  hash: "",
  emailDomain: "",
  canAccessAlerts: false //set in false by default
};

export const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    setUserProfile: (state, action: PayloadAction<UserProfile>) => {
      const incoming = action.payload;
      //Extract domain from the incoming email
      const domain = incoming.email.includes("@")
        ? incoming.email.split("@")[1]
        : "";
      //Merge it all back into state, including emailDomain
      return {
        ...state,
        ...incoming,
        emailDomain: domain,
      };
      // return { ...state, ...action.payload };
    },
    setEmailDomain: (state, action: PayloadAction<string>) => {
      state.emailDomain = action.payload;
    },
    clearUserProfile: () => {
      return initialState;
    },
  },
});

// Exporta acciones y reducer
export const { setUserProfile, clearUserProfile, setEmailDomain} = userProfileSlice.actions;
export default userProfileSlice.reducer;
